import DelayedRecaptchaLoader from "util/DelayedRecaptchaLoader";

export function handleGravityForms() {
    let $forms = $(".gform_wrapper");

    if ($forms.length > 0) {
        $forms.each((i, el) => {
            let $el = $(el);
            let $recaptcha = $el.find('.ginput_recaptcha');

            if($recaptcha.length > 0) {
                new DelayedRecaptchaLoader($el.parents('.container'));
            }
        });
    }
}